import * as React from 'react';
import styled from 'styled-components';
import { Checkbox as MaterialCheckbox, FormControlLabel } from '@mui/material';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const CheckboxComponent = styled(MaterialCheckbox)<{ checked?: boolean }>`
    color: ${({ checked }) =>
        checked
            ? getColor('lightBlue')
            : getColor('lightBorderColor')};
    margin-top: -2px;

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right: 15px;
    height: 20px;
    margin-left: 0px;
    margin-top: 5px;

    & .css-1jwbes-MuiButtonBase-root-MuiCheckbox-root {
        padding:3px;
    }


    & .MuiFormControlLabel-label {
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('small')};
        line-height: ${getLineHeight('small')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

type Props = {
    label: string;
    checked: boolean;
    handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    indeterminate?: boolean;
};

export const Checkbox: React.FC<Props> = ({
    label,
    checked,
    handleOnChange,
    indeterminate = false,
}) => (
    <StyledFormControlLabel
        control={
            <CheckboxComponent
                color='default'
                checked={checked}
                onChange={handleOnChange}
                indeterminate={indeterminate}
            />
        }
        label={label}
    />
);
